import type { AxiosError } from "axios";
import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import apiBase from "../../utils/apiBase";

export interface Organization {
  id: string;
  name: string;
  tenantId: string;
}
export interface ISubscription {
  id: string;
  externalId: string;
  externalName: string;
  organizationId: string;
  purchaserId: string;
  purchaserUpn: string;
  purchaserTenantId: string;
  beneficiaryId: string;
  beneficiaryUpn: string;
  beneficiaryTenantId: string;
  planId: string;
  offerId: string;
  status: string;
  createdAt: string;
  quantity: number;
  planType: string;
  isTrial: boolean;
  organizations: Organization[];
}

const getSubscriptions = async (
  token: string | null,
): Promise<ISubscription | undefined> => {
  return await apiBase.post("/subscriptions", { token });
};
export const useSubscriptions = (
  token: string | null,
): UseQueryResult<any, AxiosError> => {
  return useQuery(["subscriptions", token], () => getSubscriptions(token), {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};

export const activateSubscription = async (
  subscriptionId: string,
  planId: string,
  organizationId: string,
): Promise<boolean> => {
  try {
    const response = await apiBase.post(
      `/subscriptions/${subscriptionId}/activate`,
      {
        planId,
        organizationId,
      },
    );
    console.log("activateSubscription RESPONSE", response);
    return true;
  } catch (error) {
    return false;
  }
};
